// extracted by mini-css-extract-plugin
export default {"checkboxWrapper":"checkbox-wrapper_checkboxWrapper__opgYB","checkboxContainer":"checkbox-wrapper_checkboxContainer__C7gMs","checkbox":"checkbox-wrapper_checkbox__8h5JU"};